export default (isFavorites = false, lang = null) => ({
	currentCategory: 0,
	type: null,
	isMenuOpen: false,
	menuId: null,
	exercises: [],
	page: 1,
	hasMore: true,
	loading: false,
	isFavoritePage: isFavorites === 'true',
	fetchUrl: '/actions/website/exercise/get-exercises',
	lang: null,
	selectedTags: [],

	init() {
		console.log("Exercise list component initialized");
		this.lang = lang;

		if (this.isFavoritePage) {
			this.fetchUrl = '/actions/website/exercise/get-favorites';
		}

		if(window.location.hash.indexOf('orders') > -1) {
			this.type = 'orders';
		}
		
		this.fetchProducts();
 		this.getSelectedTag();

		window.addEventListener('selectionsTabChanged', (event) => {
			const selectedTab  = event.detail.tabIndex;
			let type = null;
			console.log("Selected tab changed:", event.detail.tabIndex, selectedTab === 1);
			this.currentCategory = 0; // Reset category when tab changes
			if (selectedTab === 0) {
				type = null;
			} else if (selectedTab === 1) {
				type = "orders";
			}

			this.setType(type);
		});

	},
	fetchProducts() {
		if (this.loading) return; // Prevent multiple fetches
		this.loading = true;
		fetch(`${this.fetchUrl}?category=${this.currentCategory}&page=${this.page}&type=${this.type}&lang=${this.lang}`)
			.then(response => response.json())
			.then(data => {
				console.log("Fetching products for category:", data);
				this.exercises.push(...data.products);
				this.hasMore = this.exercises.length < parseInt(data.total) && this.exercises.length > 0;
				this.loading = false;
				this.$nextTick(() => {
					if (window.lazyloadInstance) {
						window.lazyloadInstance.update();
					}
				});
			})
			.catch(error => {
				console.error("Error fetching products:", error);
			});
		this.getSelectedTag();
	},
	loadMore() {
		this.page += 1;
		this.fetchProducts();
	},
	showMenu(id) {
		console.log("Showing menu for ID:", id);
		this.menuId = id;

	},
	setCategory(cat) {
		console.log("Setting category to:", cat);
		this.currentCategory = cat;
		const element = document.querySelector('[data-theme-id="'+cat+'"]');
		if (element) {
			this.page = 1; // Reset page to 1 when changing category
			this.exercises = []; // Clear existing exercises
			this.fetchProducts();
		}

		this.menuId = null;
	},
	setType(type) {
		console.log("Setting type to:", type);
		this.type = type;
		this.page = 1; // Reset page to 1 when changing type
		this.exercises = []; // Clear existing exercises
		this.fetchProducts();

		if (type === 'orders') {
			window.history.pushState({}, '', `#${type}`);
		} else {
			window.history.pushState({}, '', window.location.pathname);
		}

		this.menuId = null;
	},
	reset() {
		this.currentCategory = 0;
		this.type = null;
		this.page = 1; // Reset page to 1 when changing type
		this.exercises = []; // Clear existing exercises
		this.fetchProducts();
		window.history.pushState({}, '', window.location.pathname);
		this.menuId = null;
	},
	getSelectedTag() {
		const theme = document.querySelector('[data-theme-id="'+this.currentCategory+'"]').textContent.trim() || '';
		let type = document.querySelector('[data-theme-id="'+this.type+'"]') ? document.querySelector('[data-theme-id="'+this.type+'"]').textContent.trim() : '';
		type = theme == type ? '' : type; 
		this.selectedTags = [theme, type].filter(tag => tag.trim() !== '');
	}
});
